import React from "react";
import Slider from "react-slick";
import { ChevronRight, ChevronLeft } from "react-feather";

const NextArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={`${className} slick-next--custom`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <ChevronRight width={48} height={48}/>
    </div>
  )
}

const PrevArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={`${className} slick-prev--custom`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <ChevronLeft width={48} height={48}/>
    </div>
  )
}

const Carousel = ({children, isMobile, slidesToScroll, slidesToShow, initialSlide, images, className}) => {
  const settings = {
    initialSlide: initialSlide || 0,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow || 1,
    slidesToScroll: slidesToScroll || 1,
    // adaptiveHeight: true,
    dotsClass: 'slick-dots--image',
    appendDots: dots => <ul>
      {dots.map((item, index) => {
        console.log(item)
        return (
          <li key={index}>
            {item.props.children}
          </li>
        );
      })}
    </ul>,
    customPaging: index => {
      return (
        <button>
          <div
            style={{width: '50px', height: '50px', backgroundImage: `url('${images[index]}')`}}
            className="bg-no-repeat bg-cover bg-center slick-dot-image rounded"
          />
        </button>
      )
    },
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div className={`${className} slick-fullwidth gallery-carousel`}>
      <Slider {...settings}>
        {
          images.map((src, index) => (
            <div key={index}>
              <div
                style={{width: '100%', height: isMobile ? '188px' : '546px', backgroundImage: `url('${images[index]}')`}}
                className="bg-no-repeat bg-cover bg-center slick-dot-image rounded"
              />
            </div>
          ))
        }
      </Slider>
    </div>
  )
}

export { Carousel }